import { useTranslation } from 'react-i18next';

export default function WhyChooseUs() {
  const { t } = useTranslation();
  
  const points = [
    { h: t('whyChoose.expertise'), p: t('whyChoose.expertise.desc') },
    { h: t('whyChoose.turnaround'), p: t('whyChoose.turnaround.desc') },
    { h: t('whyChoose.transparent'), p: t('whyChoose.transparent.desc') },
    { h: t('whyChoose.quality'), p: t('whyChoose.quality.desc') }
  ];
  
  return (
    <section id="why" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">{t('whyChoose.title')}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{t('services.subtitle')}</p>
        </div>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {points.map(p => (
            <div key={p.h} className="p-6 rounded-xl bg-white border border-gray-200 shadow-sm hover:shadow-md transition">
              <h3 className="font-semibold text-lg mb-2 text-gray-800">{p.h}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{p.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
